import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import style from "./profile.module.scss";
import FileUploadOutlinedIcon from "@mui/icons-material/FileUploadOutlined";
import { Button, Spinner } from "react-bootstrap";
import ProfileService from "../../../service/profile";

function VerifyKyc(props) {
  const { t } = useTranslation();
  const [data, setData] = useState({
    idProof: null,
    idProofwithSelfie: null,
    selectedIdproof: "",
    selectedIdSelfie: "",
  });

  const [alert, setAlert] = useState({
    show: false,
    message: "",
    type: "",
  });

  const [loader, setLoader] = useState(false);

  const fileChangeHandler = (e, type) => {
    if (type === "id") {
      setData((prev) => ({
        ...prev,
        idProof: e.target.files[0],
        selectedIdproof: e.target.files[0].name,
      }));
    } else if (type === "selfie") {
      setData((prev) => ({
        ...prev,
        idProofwithSelfie: e.target.files[0],
        selectedIdSelfie: e.target.files[0].name,
      }));
    }
  };

  const fileSubmitHandler = () => {
    setLoader(true);
    const service = new ProfileService();
    const formData = new FormData();

    // ✅ I-append lang ang files na kailangan
    if (props.kycDocs.includes("ID Proof") && data.idProof) {
      formData.append("idproof", data.idProof);
    }
    if (props.kycDocs.includes("Selfie Holding ID") && data.idProofwithSelfie) {
      formData.append("idproofSelfie", data.idProofwithSelfie);
    }

    service.uploadFile(formData).then((res) => {
      setLoader(false);
      if (res.status) {
        props.checkKyCsubmitstatus(true);
        setAlert({
          show: true,
          message: t("Common.fileuploaded"),
          type: "success",
        });
        setTimeout(() => {
          props.onClose();
        }, 3000);
      } else {
        props.checkKyCsubmitstatus(false, res.error.description);
        setAlert({
          show: true,
          message: res.error.description,
          type: "danger",
        });
      }
    });
  };

  const isSubmitDisabled = () => {
    if (props.kycDocs.includes("ID Proof") && !data.idProof) {
      return true;
    }
    if (props.kycDocs.includes("Selfie Holding ID") && !data.idProofwithSelfie) {
      return true;
    }
    return loader;
  };

  return (
    <div>
      <h2 className={style.modalHeading}>{t("Common.verifyAccnt")}</h2>
      <small style={{ color: "#534747" }}>
        Verified account will allow transactions such as E-wallet transfer and
        l-Lifestyle Points usage
      </small>
      <br />
      <br />
      <small style={{ color: "#534747" }}>
        Kindly process below requirements and we will review
      </small>
      <br />
      <br />

      {/* ✅ ID Proof — show lang kung nasa docs */}
      {props.kycDocs && props.kycDocs.includes("ID Proof") && (
        <div className={style.dropzoneWrapper}>
          <div className={style.dropzoneDesc}>
            <center>
              <FileUploadOutlinedIcon color="disabled" />
              &nbsp;&nbsp;
              <span
                style={{
                  color: "grey",
                  fontWeight: "bold",
                  marginTop: "1px",
                }}
              >
                {t("Common.uploadId")}
              </span>
            </center>
            {data.selectedIdproof && (
              <span style={{ fontSize: "15px", fontWeight: "bold" }}>
                {data.selectedIdproof}
              </span>
            )}
          </div>
          <input
            type="file"
            name="banner_image"
            id="banner_image"
            className={style.dropzone}
            onChange={(e) => fileChangeHandler(e, "id")}
          />
        </div>
      )}

      {/* ✅ Selfie Holding ID — show lang kung nasa docs */}
      {props.kycDocs && props.kycDocs.includes("Selfie Holding ID") && (
        <div className={style.dropzoneWrapper} style={{ marginTop: "1em" }}>
          <div className={style.dropzoneDesc}>
            <center>
              <FileUploadOutlinedIcon color="disabled" />
              &nbsp;&nbsp;
              <span
                style={{
                  color: "grey",
                  fontWeight: "bold",
                  marginTop: "1px",
                }}
              >
                {t("Common.uploadselfieId")}
              </span>
            </center>
            {data.selectedIdSelfie && (
              <span style={{ fontSize: "15px", fontWeight: "bold" }}>
                {data.selectedIdSelfie}
              </span>
            )}
          </div>
          <input
            type="file"
            name="banner_image"
            id="banner_image"
            className={style.dropzone}
            onChange={(e) => fileChangeHandler(e, "selfie")}
          />
        </div>
      )}

      <div style={{ display: "flex" }}>
        <Button className={style.closebtn} onClick={props.onClose}>
          {window.location.pathname.includes("/dashboard") ? (
            <small>{t("Button.skip").toUpperCase()}</small>
          ) : (
            <small>{t("Button.close").toUpperCase()}</small>
          )}
        </Button>
        <Button
          className={style.submitbtn}
          onClick={fileSubmitHandler}
          disabled={isSubmitDisabled()}
        >
          <small>
            {loader ? (
              <Spinner animation="border" size="sm" />
            ) : (
              t("Button.submit").toUpperCase()
            )}
          </small>
        </Button>
      </div>
    </div>
  );
}

export default VerifyKyc;